import React from 'react';
import './BlacklistStatusCard.css';

const BlacklistStatusCard = ({ scanData }) => {
  const blacklistServices = [
    { name: 'Google Safe Browsing', key: 'google_safe_browsing' },
    { name: 'McAfee', key: 'mcafee' },
    { name: 'Sucuri Labs', key: 'sucuri_labs' },
    { name: 'ESET', key: 'eset' },
    { name: 'PhishTank', key: 'phishtank' },
    { name: 'Yandex', key: 'yandex' },
    { name: 'Opera', key: 'opera' }
  ];

  const blacklistData = scanData?.blacklist_status || {};
  
  const isClean = (serviceKey) => {
    return blacklistData[serviceKey] !== 'blacklisted' && blacklistData[serviceKey] !== 'suspicious';
  };

  return (
    <div className="blacklist-status-card">
      <div className="card-header">
        <h3>Website Blacklist Status</h3>
      </div>
      <div className="blacklist-items">
        {blacklistServices.map((service) => (
          <div key={service.key} className="blacklist-item">
            <div className="blacklist-icon" style={{ color: isClean(service.key) ? '#28a745' : '#dc3545' }}>
              {isClean(service.key) ? '✓' : '✗'}
            </div>
            <div className="blacklist-label">
              Domain clean by {service.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlacklistStatusCard;

